import axios from "../../../core/axiosInstance"

const postPosition = async data =>
  await axios.post(`career-page/avalith/jobs/79953/apply/`, data)

export { postPosition }
